import { zergApi } from "@/service/zerg";

class ScheduleService {
  async getScheduleInfo(payload) {
    try {
      const data = await zergApi.post("/rrhh/schedule/import-excel", payload);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async listSchedulesAreas() {
    try {
      const data = await zergApi.get("/area/list");
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getUsersModule(payload) {
    try {
      const data = await zergApi.post(
        "/rrhh/schedule/get-current-module",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  async insertSchedule(payload) {
    try {
      const data = await zergApi.post(
        "/rrhh/schedule/insert-schedule",
        payload
      );
      return data;
    } catch (error) {
      throw error;
    }
  }

  async listScheduleModules(params) {
    const data = await zergApi.post("/rrhh/schedule/list-modules-schedules", params);
    return data;
  }

  async getHourReport(params) {
    const data = await zergApi.post("/rrhh/schedule/get-hour-report", params);
    return data;
  }

  async getExportExcel(params) {
    const { data } = await zergApi.post("/rrhh/schedule/get-export-excel", params, {
      responseType: "blob",
    });
    return data;
  }

  async getEmployeeJustifications(params) {
    try {
      const data = await zergApi.post("/rrhh/attendance/get-employee-justifications", params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getEmployeeJustification(params) {
    try {
      const data = await zergApi.post("/rrhh/attendance/get-employee-justification", params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getAttendanceReport(params) {
    try {
      const data = await zergApi.post("/rrhh/attendance/get-attendance-report", params);
      return data;
    }
    catch (error) {
      throw error;
    }
  }

  async getNotificacionFaltas(params) {
    try {
      const data = await zergApi.post("/rrhh/attendance/get-notificacion-faltas", params);
      return data;
    }
    catch (error) {
      throw error;
    }
  }

  async storeMarkScheduleJustification(params) {
    try {
      const headers = {
        "Content-Type": "multipart/form-data",
      };
      const data = await zergApi.post("/rrhh/justifications/store-mark-schedule-justification", params, headers);
      return data;
    } catch (error) {
      throw error;
    }
  }


  async listJustificationTypes() {
    try {
      const data = await zergApi.get("/rrhh/justification-types/list-justification-types");
      return data;
    } catch (error) {
      throw error;
    }
  }

  async listEmployeeJustificationsByStatus(params) {
    try {
      const data = await zergApi.post("/rrhh/justifications/list-employee-justifications-by-status", params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async listEmployeeJustificationsByStatusExcel(params) {
    try {
      const data = await zergApi.post(`/rrhh/justifications/list-employee-justifications-by-status-excel`, params, {
        responseType: "blob",
      });
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getJustification(params) {
    try {
      const data = await zergApi.post("/rrhh/justifications/get-justification", params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async updateJustification(params) {
    try {
      const data = await zergApi.post("/rrhh/justifications/update-mark-schedule-justification", params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async getJustificationByDate(params) {
    try {
      const data = await zergApi.post("/rrhh/justifications/get-justification-by-date", params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async createManualAttendance(params) {
    try {
      const data = await zergApi.post("/rrhh/justifications/create-manual-attendance", params);
      return data;
    } catch (error) {
      throw error;
    }
  }

  async exportToExcel(params) {
    try {
      const data = await zergApi.post("/rrhh/attendance/export-attendance-to-excel", params, {
        responseType: "blob",
      })
      return data
    } catch (error) {
      throw error
    }
  }
}

export default new ScheduleService();
